import { render, staticRenderFns } from "./AccountSettingsDetails.html?vue&type=template&id=83533384&scoped=true&"
import script from "./AccountSettingsDetails.ts?vue&type=script&lang=ts&"
export * from "./AccountSettingsDetails.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_settings-details.scss?vue&type=style&index=0&id=83533384&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83533384",
  null
  
)

export default component.exports